import SystemUpdateAltOutlinedIcon from '@mui/icons-material/SystemUpdateAltOutlined';
import { Button } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { selectLoggedIn } from "../../store/userSlice/userSelectors";
import { downloadFile } from "../../helpers/request";
import { createAllCertificateLink, createAllReportLink } from "../../helpers/urlBuilder";
import { addAlert } from "../../store/alertSlice/alertSlice";

const DownloadButton = ({ companyId, isReports = false, isArchive = false }) => {
  const dispatch = useDispatch();
  const isLoggedIn = useSelector(selectLoggedIn);
  const archiveUrl = isReports ? createAllReportLink(companyId, isArchive) : createAllCertificateLink(companyId, isArchive);

  const onClick = (e) => {
    e.preventDefault();
    dispatch(addAlert({
      text: 'File download has been started',
      severity: 'success',
    }))
    downloadFile(archiveUrl);
  }

  if (!companyId) {
    return null;
  }

  return isLoggedIn ? (
      <>
        <Button
          variant="outlined"
          fullWidth
          color="secondary"
          onClick={onClick}
          startIcon={<SystemUpdateAltOutlinedIcon />}
        >
          {
            isArchive ? "Download archived files" : "Download active files"
          }
        </Button>
      </>

  ) : null;
}

export default DownloadButton;